import { useStaticQuery, graphql } from 'gatsby';

export const useAlerts = () => {
  const {
    allStrapiSiteAlert: { nodes },
  } = useStaticQuery(graphql`
    {
      allStrapiSiteAlert {
        nodes {
          key
          showAlert
          text
          bgColor
          tooltipText
          links {
            id
            linkText
            linkUrl
          }
        }
      }
    }
  `);

  return {
    alerts: nodes,
    alertsCount: nodes.length,
  };
};
